import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ClerkProvider } from "@clerk/clerk-react";
import { SignedIn, SignedOut } from "@clerk/clerk-react";
import Login from "./components/Login.js";
import ProtectedRoutes from "./routes/ProtectedRoutes.js";
import { AuthContextProvider } from "./context/authContext.js";

const clerkFrontendApi = process.env.REACT_APP_CLERK_FRONTEND_API;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
   
      <BrowserRouter>
   
        
            <App />
        
       
      </BrowserRouter>
   
  </React.StrictMode>
);

// Measure app performance and log results
// reportWebVitals(console.log);
